<template>
  <div id="HolterDepositMachineRequest">
    <section>
      <div id="container-center">
        <form>
        <h1 style="" class="title has-text-centered printTarget">院内貸出機登録画面</h1>
        <div>
          <b-steps v-model="activeStep" :animated="true" :rounded="true" :has-navigation="false" label-position="bottom">
            <b-step-item step="1" label="基本情報" icon="clipboard-edit-outline">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="home" @click.prevent="goHome">ホーム画面 </b-button>
                  <b-button class="is-primary" style="float:right;" icon-right="chevron-double-right" :disabled="!isChecked" @click.prevent="Forward">次へ</b-button>
                  <span>申込み内容を入力してください。</span>
                </div>
                <div class="card-content margin-top">
                  <table>
                    <tr><th>医療機関名<span class="require"/></th>
                      <td>
                        <template>
                          <input type="text" style="width:730px;height:27px;" v-model="reqParams.hospitalName" class="1" name="医療機関名" validate="required" disabled />
                          <b-button style="margin-left:10px; width:150px; height:27px;" @click="organizationModalActive=true">医療機関選択</b-button>
                        </template>
                      </td>
                    </tr>
                    <tr><th>医師名</th><td><input type="text" v-model="reqParams.doctorName" :disabled="isAddDeposit" maxlength="105"/></td></tr>
                    <tr><th>事務担当者名</th><td><input type="text"  v-model="reqParams.clerkName" :disabled="isAddDeposit" maxlength="100"/></td></tr>
                    <tr><th>機種<span class="require" name="item_step1" id="model"/></th><td><select id="model" class="1" name="機種" validate="required" :disabled="isAddDeposit" @change="changeModel" v-model="reqParams.model"><option v-for="model in modelList" :value="model.value" :key="model.value">{{ model.label1 }}</option></select></td></tr>
                    <tr>
                      <th>検査期間<span class="require" name="item_step1" id="period"/></th>
                      <td>
                        <select v-model="reqParams.inspectionPeriod" class="1" name="検査期間" validate="required" :disabled="isAddDeposit || !reqParams.hospitalName || inspectionPeriodList.length <= 1">
                          <option v-for="inspectionPeriod in inspectionPeriodList" :value="inspectionPeriod.value" :key="inspectionPeriod.value">{{ inspectionPeriod.label1 }}</option>
                        </select>
                      </td>
                    </tr>
                    <tr v-if="reqParams.hospitalName && inspectionPeriodList.length <= 1"><th></th><td>現在、ご契約済の検査期間はございません。営業担当にお問い合わせください。</td></tr>
                    <tr v-if="false">
                      <th>解析オプション（有料）<span class="require" name="item_step1" id="option"/></th>
                      <td>
                        <select v-model="reqParams.analysisOption" class="1" name="解析オプション（有料）" @change="changedAnalysisOption" validate="required">
                          <option v-for="analysisOption in analysisOptionList" :value="analysisOption.value" :key="analysisOption.value">{{ analysisOption.label1 }}</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <th>契約院内貸出機台数<span class="require" name="item_step1" id="depositmachinerentalnum"/></th>
                      <td style="display:flex">
                        <template v-if="reqParams.maxDepositNumber > 5">
                          <input v-model="reqParams.depositMachineRentalNumber" class="1" name="契約院内貸出機台数" :disabled="true" validate="required">
                        </template>
                        <template v-else>
                          <select v-model="reqParams.depositMachineRentalNumber" class="1" name="契約院内貸出機台数" :disabled="isDisabledRentalNumber" @change="changedAnalysisOption" validate="required">
                            <option></option>
                            <option v-for="n in canRentalNumber" :key="n" :value="n">{{ n }}</option>
                          </select>
                        </template>
                        <div style="width:20%; margin-left: 10px;">
                          現在貸出台数：{{reqParams.alreadyDepositNumber}}台
                        </div>
                      </td>
                    </tr>
                    <tr><th>【機器配送先】</th>
                    <tr>
                      <th>郵便番号<span class="require"/></th>
                      <td>
                        <input id="zip" style="width:250px;height:27px;" v-model="reqParams.zip" class="1" :class="{'border-red': invalidShippingPostcode}" :disabled="isAddDeposit" name="機器配送先の郵便番号" validate="required|numeric|zip" maxlength="7" placeholder="ハイフン(-)なし。7桁。例)1234567" @blur="onZipBlur(reqParams.zip, 'digitErrorPostcode')" @paste="onPaste"/>
                        <b-button style="margin-left:10px; width:150px; height:27px;" :disabled="isAddDeposit" v-on:click="addressSearch('device',reqParams.zip)">自動入力</b-button>
                        <div v-show="invalidShippingPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                        <div v-show="digitErrorPostcode" class="text-red">{{ digitErrorZipMessage }}</div>
                      </td>
                    </tr>
                    <tr><th>住所（都道府県、市町村区）<span class="require" style="margin-left:-8px;"/></th><td><input type="text" v-model="reqParams.address" class="1" name="機器配送先の住所（都道府県、市町村区）" validate="required" :disabled="isAddDeposit" maxlength="280"/></td></tr>
                    <tr><th>住所（それ以降の住所）<span class="require"/></th><td><input type="text" v-model="reqParams.address1" class="1" name="機器配送先の住所（それ以降の住所）" validate="required" :disabled="isAddDeposit" maxlength="256" ref="address1"/></td></tr>
                    <tr><th>住所（建物名、部屋番号）</th><td><input type="text" v-model="reqParams.address2" maxlength="256" :disabled="isAddDeposit"/></td></tr>
                    <tr><th>宛名<span class="require"/></th><td><input type="text" v-model="reqParams.receiverName" maxlength="100" class="1" name="機器配送先の宛名" validate="required" :disabled="isAddDeposit"/></td></tr>
                    <tr><th>連絡先(電話番号)<span class="require"/></th><td><input type="tel" :class="{'border-red': invalidShippingPhoneNumber}" v-model="reqParams.phoneNumber" maxlength="11" :placeholder="phonePlaceholder" class="1" name="機器配送先の連絡先(電話番号)" validate="required|numeric" :disabled="isAddDeposit"/><div v-show="invalidShippingPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div></td></tr>
                    <tr><th>配達希望時間帯</th><td><select v-model="reqParams.desiredDeliveryTimeZone" :disabled="isAddDeposit"><option v-for="timeZone in desiredDeliveryTimeZoneList" :value="timeZone.value" :key="timeZone.value">{{ timeZone.label1 }}</option></select></td></tr>
                    <tr><th colspan="2">【ePatch】</th></tr>
                    <tr><th>出荷日<span  class="require" name="item_step1" id="shippingDate"/></th>
                      <td>
                        <input type="date" v-model="reqParams.shippingDate"  class="shippingDate 1"  name="出荷日" validate="required|date" disabled style="width:150px;height:27px;"/><a @click="officeCalenderActive = true"><b-icon icon="calendar-cursor"></b-icon></a>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        注意事項<span class="require" />
                      </th>
                      <td>
                        <b-checkbox class="cstmCheckBox" v-model="isChecked">Creative Web Flowで院内貸出機申請の上長承認を取得しました</b-checkbox>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="2" label="申込み" icon="account">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward" >前へ</b-button>
                  <span>以下の申込み内容を確認のうえ、下部の「申込みを完了する」ボタンを押下してください。</span>
                </div>
                <!--　申込み詳細 -->
                <HolterDepositMachineDetail v-bind:data="reqParams" v-bind:depositMachineFlag="true" v-bind:depositMachineCancelFlag="false" v-bind:key="renderKey"/>
                <b-button class="is-primary" style="margin-top:5px;width:250px;" @click="requestHolter">申込みを完了する</b-button>
              </div>
            </b-step-item>
            <b-step-item step="3" label="完了" icon="check">
              <section class="unPrintTarget">
                <div class="request-title"><span>ホルター心電図配送ｻｰﾋﾞｽの申込みを受け付けました。</span></div>
                <div class="margin-top">
                  <b-button class="backbutton is-primary" @click="back">戻る</b-button>
                  <b-button class="printbutton is-primary" icon-left="printer" @click="print">印刷</b-button>
                </div>
              </section>
              <section class="printTarget">
                <div id="item-contens">
                  <div class="card-content margin-top printMargin">
                    <table>
                      <tr><th colspan="2">【{{reqParams.model | getNameFilter(modelList)}}】</th></tr>
                      <tr><th>受付日時</th><td>{{requestDate}}</td></tr>
                      <tr><th>受付番号</th><td>{{receiptNumber}}</td></tr>
                    </table>
                  </div>
                </div>
                <HolterDepositMachineDetail v-bind:data="reqParams" v-bind:key="renderKey"/>
              </section>
            </b-step-item>
          </b-steps>
        </div>
        </form>
      </div>
    </section>
    <b-modal :active.sync="organizationModalActive" has-modal-card>
      <organizationSelectModal v-if="isSalesOffice || isAdmin" :selectRole="[role.role_hospital]" :selectStatus="extUserStatus.registed" :serviceId="serviceId" :holterdepositFlag="true" title="医療機関選択" labelForOrg="医療機関名" @select="setOrganization"></organizationSelectModal>
    </b-modal>
    <b-modal :active.sync="officeCalenderActive" has-modal-card>
      <officeCalenderModal :miniday="miniday" :maxDay="maxday" :disabledDays="disabledDays" @select="setShippingDate" @change-page="holterChangePage"></officeCalenderModal>
    </b-modal>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";
import {atLaunchHidden} from "@/components/mock/base/const.js";
import {choicesType,digitErrorZipMessage} from "@/components/mock/base/const.js";
import {extUserStatus} from "@/components/mock/base/const.js";
import {analysisOption} from "@/components/mock/base/const.js";
import {inspectionPeriod} from "@/components/mock/base/const.js";
import holterRequest from "@/components/mock/common/HolterDepositMachineDetail";
import OrganizationSelectModal from "@/components/mock/philips/common/OrganizationSelectModal";
import OfficeCalenderModal from "@/components/mock/guest/OfficeCalenderModal";
import {service} from "@/components/mock/base/const.js";
import {phonePlaceholder} from "@/components/mock/base/const.js";
import {invalidNumberMessage} from "@/components/mock/base/const.js";

export default {
  name: "HolterDepositMachineRequest",
  methods: {
    Backward: function() {
      this.activeStep -= 1;
    },
    Forward: function(event) {
      // バリデーションチェック
      let stepItems = document.getElementsByClassName("step-item")
      let target
      for(let item of stepItems){
        if(item.getAttribute("style") != "display: none;"){
          target = item
        }
      }
      let activeStep = target ? target.getAttribute("step") : ""
      if(activeStep){
        let elements = document.getElementsByClassName(activeStep)
        let result = this.selfMadeValidation(elements)

        if(result.isError){
          this.showErrorMessage(result.msg)
        }else{
          // 再レンダリングの為、フラグ切替
          this.renderKey = !this.renderKey
          this.activeStep += 1;
        }
      }
    },
    requestHolter: function() {
      let messsage = "ePatchの院内貸出機を申込みます。<br/>内容に間違いないことを確認して「OK」ボタンを押してください。<br/><span style=\"font-size: 14px;\">※申込み後のキャンセルは案件検索の受付番号をクリックし、院内貸出解除をしてください。</span>"
      this.$dialog.confirm({
        title: "申込み確認",
        message: messsage,
        cancelText: "修正する",
        onConfirm: async () => {
          this.compleateFlg = true;
          let excuteApi = this.setHolterDepositMachineApplicationPOST;
          let successCallBack = this.setHolterDepositMachineApplicationPOSTSuccess;
          let errorCallBack = this.setHolterDepositMachineApplicationPOSTError;
          // WebAPI Call
          await this.apiCall(excuteApi, successCallBack, errorCallBack)
          if(this.compleateFlg && this.requestDate && this.receiptNumber){
            this.jumpToTop();
            this.activeStep += 1;
          }else {
            this.showErrorMessage("申請の処理に失敗しました。\n再度「完了」のボタンをクリックしてください。\nこのメッセージが繰り返し表示される場合は、Philips営業担当者にご連絡ください。");
          }
        }
      });
    },
    back: function() {
      this.$router.go(-1);
    },
    goHome: function() {
      this.back();
    },
    changeModel: async function() {
      let _this = this
      _this.reqParams.shippingDate = ""
      _this.reqParams.returnDate = ""
      
      //最短出荷日の変更
      //●ePatch：翌営業日まで選択できない　　（申込時点から2営業日目は選択可能）
      await this.getBusinessDayPOST(null, 2, function(result) {
        _this.miniday = new Date(result.obj.date)
      })
    },
    changedAnalysisOption: async function() {
      this.reqParams.judgmentFlag = this.reqParams.analysisOption == this.analysisOption.includedAll
    },
    setShippingDate: function(selectDate){
      this.reqParams.shippingDate = selectDate
      this.officeCalenderActive = false;
      this.isInitialZip = true;
    },
    holterChangePage: function(sDate, eDate) {
      this.changePage(sDate, eDate, this.reqParams.model)
    },
    changePage: function(sDate, eDate, modelId) {
      let _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalShipmentCalendar.getStockCalendarPOST({
            body: {
              startDate: sDate,
              modelId: modelId
            }
          });
        },
        function(result){
          let disabled = result.obj.filter(data => {
            if (_this.reqParams.depositMachineRentalNumber == undefined || _this.reqParams.depositMachineRentalNumber == ""){
              return true
            }else{
              return data.stock < _this.reqParams.depositMachineRentalNumber
            }
          })
          _this.disabledDays = disabled
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    setOrganization: async function(organizationInfo){
      this.organizationInfo = organizationInfo
      this.isInitialZip = true;
      let excuteApi = this.getHolterDepositMachineRequestPOST;
      let successCallBack = this.getHolterDepositMachineRequestPOSTSuccess;
      let errorCallBack = this.getHolterDepositMachineRequestPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack) 

      // 見積りコードが紐づいた検査期間を取得・設定
      this.getChoicesListLinkedEstimate()
    },
    getHolterDepositMachineRequestPOST: function(client) {
      return client.apis.externalHolter.getHolterDepositMachineRequestPOST({
        body:{
          belongsId: this.organizationInfo.id
        }
      });
    },
    getHolterDepositMachineRequestPOSTSuccess: function(result) {
      let depositRequest = result.obj
      let calcCanRentalNumber = depositRequest.maxDepositNumber - depositRequest.rentalNumber
      this.canRentalNumber = calcCanRentalNumber > 0 ? calcCanRentalNumber: 0
      if(this.canRentalNumber <= 0){
        this.showErrorMessage("選択された医療機関への院内貸出台数が上限に達しています。")
        return 
      }
      this.isDisabledRentalNumber = false
      this.isAddDeposit = depositRequest.receiptNumber? true: false
      this.reqParams.maxDepositNumber = depositRequest.maxDepositNumber
      this.reqParams.belongsId = this.organizationInfo.id + "";
      this.reqParams.hospitalName = this.organizationInfo.orgName;
      this.belongsId = this.organizationInfo.id;
      this.reqParams.holterJudgmentFlg = this.organizationInfo.holterJudgmentFlg;

      if(this.isAddDeposit){
        this.reqParams.doctorName = depositRequest.doctorName
        this.reqParams.clerkName = depositRequest.clerkName
        this.reqParams.inspectionPeriod = depositRequest.inspectionPeriod
        this.reqParams.zip = depositRequest.zip
        this.reqParams.address = depositRequest.address
        this.reqParams.address1 = depositRequest.houseNumber
        this.reqParams.address2 = depositRequest.building
        this.reqParams.receiverName = depositRequest.destination
        this.reqParams.phoneNumber = depositRequest.phoneNumber
        this.reqParams.desiredDeliveryTimeZone = depositRequest.desiredPickupTimeZone
        this.reqParams.resultZip = depositRequest.zip;
        this.reqParams.resultAddress = depositRequest.address + depositRequest.houseNumber;
        this.reqParams.resultBuildingName = depositRequest.building
        this.reqParams.resultPhoneNumber = depositRequest.phoneNumber
        this.reqParams.alreadyDepositNumber = depositRequest.rentalNumber
      } else {
        this.reqParams.doctorName = ""
        this.reqParams.clerkName = ""
        this.reqParams.inspectionPeriod = ""
        this.reqParams.zip = this.organizationInfo.zip;
        this.reqParams.address = this.organizationInfo.prefecture + this.organizationInfo.city;
        this.reqParams.address1 = this.organizationInfo.address;
        this.reqParams.address2 = this.organizationInfo.building ? this.organizationInfo.building : "";
        this.reqParams.receiverName = this.organizationInfo.orgName;
        this.reqParams.phoneNumber = this.organizationInfo.phoneNumber;
        this.reqParams.desiredDeliveryTimeZone = ""
        this.reqParams.resultReceiverName = this.organizationInfo.orgName;
        this.reqParams.resultZip = this.organizationInfo.zip;
        this.reqParams.resultAddress = this.organizationInfo.prefecture + this.organizationInfo.city + this.organizationInfo.address;
        this.reqParams.resultBuildingName = this.organizationInfo.building ? this.organizationInfo.building : "";
        this.reqParams.resultPhoneNumber = this.organizationInfo.phoneNumber;
        this.reqParams.alreadyDepositNumber = 0
      } 

      if(depositRequest.maxDepositNumber > 5){
        this.reqParams.depositMachineRentalNumber = this.canRentalNumber
      }
      
    },
    getHolterDepositMachineRequestPOSTError: function(result) {
      this.showErrorMessage(result);
    },
    getChoicesListLinkedEstimate: function() {
      var excuteApi = this.getChoicesListLinkedEstimatePOST;
      var successCallBack = this.getChoicesListLinkedEstimatePOSTSuccess;
      var errorCallBack = this.getChoicesListLinkedEstimatePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getChoicesListLinkedEstimatePOST: function(client){
      let belongId = this.reqParams.belongsId? this.reqParams.belongsId: this.belongsId
      let institutionId = 0

      return client.apis.apiCommon.getChoicesListLinkedEstimatePOST({
        body: {
          belongId: belongId,
          institutionId: institutionId
        }
      });
    },
    getChoicesListLinkedEstimatePOSTSuccess: function(result) {
      //検査期間リストをAPIからの取得値から抽出
      if(this.reqParams.holterJudgmentFlg) {
        this.inspectionPeriodList = result.obj.filter(data => { return data.choicesType == this.choicesType.holterInspectionPeriodJudgment});
      }else{
        this.inspectionPeriodList = result.obj.filter(data => { return data.choicesType == this.choicesType.holterInspectionPeriod });
      }
      this.inspectionPeriodList.unshift({})
    },
    getChoicesListLinkedEstimatePOSTError: function(result){
      this.showErrorMessage(result);
    },
    print: function(){
      window.print();
    },
    setHolterDepositMachineApplicationPOST: function(client) {
      let obj = JSON.parse(JSON.stringify(this.reqParams));
      obj.shippingDate = obj.shippingDate ? obj.shippingDate.replace(/-/g, "/") : ""
      obj.belongsId = this.belongsId
      return client.apis.externalHolter.setHolterDepositMachineApplicationPOST({
        body:obj
      });
    },
    setHolterDepositMachineApplicationPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.requestDate = result.obj.requestDate
      this.receiptNumber = result.obj.receiptNumber
      this.compleateFlg = true;
    },
    setHolterDepositMachineApplicationPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    addressSearch: function(target,val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return; 
        if(target!="result"){
          this.reqParams.address = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
          this.reqParams.address1 = "";
          this.reqParams.address2 = "";

          // QA476 住所設定後フォーカスを移動する
          this.focusMove("address1");
          this.digitErrorDeliveryPostcode = false;
        }else{
          this.reqParams.resultAddress = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
          this.reqParams.resultBuildingName = ""
        }
      })
    },
    postCodeSearch: function(){
      let excuteApi = this.getAddressFromPostCodePOST;
      let successCallBack = this.getAddressFromPostCodePOSTSuccess;
      let errorCallBack = this.getAddressFromPostCodePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAddressFromPostCodePOST: function(client) {
      return client.apis.apiCommon.getAddressFromPostCodePOST({
        body:{
          postCode:this.searchTargetPostCode
        }
      });
    },
    getAddressFromPostCodePOSTSuccess: function(result) {
      this.searchTargetAddress = result.obj
      this.searchTargetPostCode = ""
    },
    getAddressFromPostCodePOSTError: function(result) {
      this.searchTargetPostCode = ""
    },
    getChoicesList: async function() {
      this.modelList = this.getChoiceList(this.choicesType.holterKind, false);
      this.desiredDeliveryTimeZoneList = this.getChoiceList(this.choicesType.deliveryTime, false);
      this.inspectionPurposeList = this.getChoiceList(this.choicesType.holterInspectionPurpose, false);
      this.analysisOptionList = this.getChoiceList(this.choicesType.holterAnalysisOp, false);
      this.inspectionPeriodList = this.getChoiceList(this.choicesType.holterInspectionPeriod, false);
      this.modelList.unshift({})
      this.desiredDeliveryTimeZoneList.unshift({})
      this.inspectionPurposeList.unshift({})
      this.analysisOptionList.unshift({})
      this.inspectionPeriodList.unshift({})
    },
    /**
     * QA476 郵便番号からフォーカスが外れたら桁数に応じて桁数判定フラグを設定する
     * @param zipCode 郵便番号
     * @param flagName 桁数判定フラグ
     */
    onZipBlur(zipCode, flagName) {
      this[flagName] = zipCode.length < 7;
    },
    /**
     * QA476 引数に指定した項目の末尾にフォーカスを移動する
     * @param refName フォーカスをあてる項目定義
     */
    focusMove(refName) {
      this.$nextTick(() => {
        const element = this.$refs[refName];
        if (element) {
          element.focus();
          const length = element.value.length;
          element.setSelectionRange(length, length);
        }
      })
    },
    onPaste() {
      this.isInitialZip = false;
    }
  },
  data() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let roleId = userInfo.roleId;
    let userId = userInfo.id;
    let miniday = new Date()
    let maxDate = new Date()
    maxDate.setDate(maxDate.getDate() + 365);
    let maxday = new Date(maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate());
    let isSalesOffice = roleId == role.role_salesOffice;
    let isAdmin = roleId == role.role_admin;
    var serviceId = service.holter;
    let return_data = {
      atLaunchHidden: atLaunchHidden,
      role: role,
      roleId: roleId,
      userId: userId,
      choicesType:choicesType,
      extUserStatus: extUserStatus,
      belongsId:userInfo.belongsId,
      organizationModalActive: false,
      isChecked: false,
      activeStep: 0,
      isSalesOffice: isSalesOffice,
      isAdmin: isAdmin,
      miniday: miniday,
      maxday:maxday,
      disabledDays: [],
      reqParams: {
        hospitalName: "",
        doctorName: "",
        clerkName:"",
        hospitalMail:"",
        zip:"",
        address:"",
        address1:"",
        address2:"",
        receiverName:"",
        phoneNumber:"",
        desiredDeliveryTimeZone:"",
        resultZip:"",
        resultAddress:"",
        resultBuildingName:"",
        resultCompanyName:"",
        resultDivision:"",
        resultReceiverName:"",
        resultPhoneNumber:"",
        model:"301",
        leadWireAdapter:false,
        returnDate:"",
        shippingDate:null,
        institutionId: "",
        memo: "",
        analysisOption:"1",
        inspectionPeriod:"",
        judgmentFlag:false,
        judgment:false,
        alreadyDepositNumber:0,
        maxDepositNumber:5,
      },
      organizationInfo:{},
      compleateFlg:false,
      searchTargetPostCode:"",
      searchTargetAddress:null,
      requestDate:"",
      receiptNumber:"",
      renderKey:true,
      officeCalenderActive: false,
      modelList:[],
      desiredDeliveryTimeZoneList:[],
      analysisOption:analysisOption,
      inspectionPurposeList:[],
      analysisOptionList:[],
      inspectionPeriodList:[],
      isChecked:false,
      canRentalNumber:0,
      isAddDeposit:false,
      isDisabledRentalNumber:true,
      serviceId,
      invalidShippingPostcode: false,
      invalidShippingPhoneNumber: false,
      // template message
      invalidNumberMessage,
      digitErrorZipMessage,
      digitErrorPostcode:false,
      isInitialZip:true,
    };

    return return_data;
  },
  computed: {
    // 電話番号入力におけるプレースフォルダー
    phonePlaceholder() {
      return phonePlaceholder;
    },
  },
  filters: {
    getNameFilter: function(val, list){
      let target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {
    organizationSelectModal:OrganizationSelectModal,
    HolterDepositMachineDetail: holterRequest,
    officeCalenderModal:OfficeCalenderModal
  },
  async mounted() {
    let _this = this
    await this.getBusinessDayPOST(null, 2, function(result) {
      _this.miniday = new Date(result.obj.date)
    })

    // マスタ取得
    await this.getChoicesList();
  },
  watch: {
    "reqParams.zip"(newValue) {
      this.invalidShippingPostcode = isNaN(Number(newValue));
      if (this.isInitialZip) {
        this.isInitialZip = false;
        return
      }
      if (!this.invalidShippingPostcode && newValue.length === 7) {
        this.addressSearch('device',newValue);
      }
    },
    "reqParams.phoneNumber"(newValue) {
      this.invalidShippingPhoneNumber = isNaN(Number(newValue));
    },
  },
};
</script>

<style>
</style>
<style lang="scss" scoped>
.shippingDate {
  width: 150px  !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/HolterDepositMachineRequest.vue